import { PROMOTIONS, SETTING, TRASH } from "../assets/icons";
import Promotion from "../views/promotion/Promotion";
import {SvgContainer} from "../components";
import theme from "../theme/theme";
import Corbeille from "../views/corbeille/Corbeille";
import Parametre from "../views/parametre/Parametre";
import { LocalRouteProps } from "../index.d";
import Passwords from "../views/parametre/components/Passwords";
import Categories from "../views/parametre/components/Categories";
import GestionUser from "../views/parametre/components/GestionUser";
import Profile from "../views/parametre/components/Profile";


const bottomRoutes: LocalRouteProps[] = [
  {
    icon: <SvgContainer svg={PROMOTIONS} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={PROMOTIONS} color={theme.colors.primary} />,
    name: "promotions",
    path: "/promotions",
    component: <Promotion />,
  },
  {
    icon: <SvgContainer svg={TRASH} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={TRASH} color={theme.colors.primary} />,
    name: "corbeille",
    path: "/corbeille",
    component: <Corbeille />,
  },
  {
    icon: <SvgContainer svg={SETTING} color={theme.colors.white} />,
    activeIcon: <SvgContainer svg={SETTING} color={theme.colors.primary} />,
    name: "parametres",
    path: "/parametres",
    component: <Parametre />,
    children: [
      {
        path: "profile",
        name: "profile",
        component: <Profile />,
      },
      {
        path: "gestion-mot-pass",
        name: "gestion_mot_pass",
        component: <Passwords />,
      },
      {
        path: "gestion-users",
        name: "gestion_users",
        component: <GestionUser />,
      },
      {
        path: "categories",
        name: "categories",
        component: <Categories />,
      },
    ],
  },
];

export default bottomRoutes;
